import { Row } from 'reactstrap';
import styled from 'styled-components';

export const Container = styled(Row)`
  margin: 1rem 0 0.9rem;
`;
